// agentic/channelEntity.ts
export class BaseWorkflow {
    constructor(socket) { this.socket = socket; }
    connect() {
        if (!this.subscribePromise) {
            this.subscribePromise = this.socket
                .subscribe(this.channelName())
                .then(sub => { this.subscription = sub; return this.subscription; });
        }
        return this;
    }
    /** @internal */
    async _getSubscription() {
        if (this.subscription)
            return this.subscription;
        if (!this.subscribePromise)
            this.connect();
        return this.subscribePromise;
    }
}
